import { useState } from "react";
import { ConfigColuna } from ".";

export function useConfigColunas(
  chaveStorage: string,
  defaultConfig: ConfigColuna[],
) {
  const [configColunas, setConfigColunas] = useState<ConfigColuna[]>(() => {
    try {
      const stored = localStorage.getItem(chaveStorage);
      return stored ? JSON.parse(stored) : defaultConfig;
    } catch {
      return defaultConfig;
    }
  });

  const isVisible = (nome: string) =>
    !configColunas.some((c) => c.nome === nome && !c.exibir);

  const salvarConfigColunas = (novaConfig: ConfigColuna[]) => {
    localStorage.setItem(chaveStorage, JSON.stringify(novaConfig));
    setConfigColunas(novaConfig);
  };

  return { configColunas, isVisible, salvarConfigColunas };
}
